import { useEffect } from "react"
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import '../styles/post-modal.scss'

function PostModal({ isOpen, onToggle, onTextChange, text, imageUrl, onConfirm, onCancel, isNewPost }) {
    useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                const postText = document.getElementById('post-text')
                postText && postText.focus()
            }, 500)
        }
    }, [isOpen])

    return (
        <Modal id="post-modal" isOpen={isOpen} toggle={onToggle}>
            <ModalHeader toggle={onToggle}><i className="bi bi-send me-2"></i>
                {isNewPost ? 'Create' : 'Edit'} Post
            </ModalHeader>
            <ModalBody>
                <Input autoFocus={true} id="post-text" value={text} onChange={onTextChange} placeholder="What's on your mind?" />

                <div id="post-image-cont">
                    <img id="post-image" src={imageUrl} alt="post-image" />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <Button color="primary" onClick={onConfirm}>
                    {isNewPost ? 'Post' : 'Update'}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default PostModal